import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../api/api';
import { formatCurrency } from '../../utils/formatCurrency';
import { getTimeAgo } from '../../utils/timeAgo';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const INITIAL_VISIBLE_COUNT = 10;
const FETCH_LIMIT = 200;

const RecentDonations = () => {
  const { t, i18n } = useTranslation();
  const [donations, setDonations] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const titleRef = useScrollReveal();
  const feedRef = useScrollReveal();

  useEffect(() => {
    api.getRecentDonations(FETCH_LIMIT).then(setDonations).catch(console.error);
  }, []);

  const visibleDonations = useMemo(
    () => (expanded ? donations : donations.slice(0, INITIAL_VISIBLE_COUNT)),
    [donations, expanded]
  );

  const hasMore = donations.length > INITIAL_VISIBLE_COUNT;

  return (
    <section className="recent-donations">
      <div className="container">
        <h2 ref={titleRef} className="section-title scroll-reveal">{t('recentDonations.title')}</h2>
        <div className="donation-feed-wrap">
          <div ref={feedRef} className="donation-feed scroll-reveal">
            {visibleDonations.map((donation) => (
              <div key={donation.id} className="donation-item">
                <div className="donor-info">
                  <div className="donor-avatar">{donation.donor_name.charAt(0)}</div>
                  <div>
                    <div style={{ fontWeight: 600 }}>{donation.donor_name}</div>
                    <div className="donation-time">{getTimeAgo(donation.donated_at, i18n.language)}</div>
                  </div>
                </div>
                <div className="donation-amount">{formatCurrency(donation.amount, i18n.language)}</div>
              </div>
            ))}
          </div>
          {hasMore && !expanded && (
            <button
              type="button"
              className="donation-feed-more"
              onClick={() => setExpanded(true)}
            >
              {t('recentDonations.showMore', '더보기')}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default RecentDonations;
